var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgNavBeranda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 2.293l9 9c.63.63.184 1.707-.707 1.707h-1v6a3 3 0 01-3 3h-1v-7a3 3 0 00-2.824-2.995L13 12h-2a3 3 0 00-3 3v7H7a3 3 0 01-3-3v-6H3c-.89 0-1.337-1.077-.707-1.707l9-9a1 1 0 011.414 0zM13 14a1 1 0 011 1v7h-4v-7a1 1 0 01.883-.993L11 14h2z"
  })));
}

export default SvgNavBeranda;